export class RegistredBiller {
    regs_id: number;
    service_name: string;
    ekpay_id: string;
    mode: string;
    biller_id: string;
    biller_name: string;
    bill_no: string;
    bill_period: string;
    bill_meter_no: string;
    bill_type: string;
    bill_xchange_code: string;
    bill_accno: string;
    bill_mobile_no: string;
    bill_last_paid_date: string;
    insert_time: Date;
    update_time: Date;
}

export class RegisterdBillerResponse {
    response: string;
    reason: string;
    registred_billers: RegistredBiller[];
}


// WEBPACK FOOTER //
// ./src/app/user/registered-biller-response.ts